module.exports = __webpack_public_path__ + "static/media/cancle-primary.af629189.svg";